module.exports = __webpack_public_path__ + "img/logo.f8df5791.svg";